import type { IntlShape } from 'react-intl';

import type { PartnerTemplatePartner } from '@/shared/api/protocol-ts/model/dto_scribe_catalog_pb';

import { partnerTemplateNameMessages, templatesMessages } from '../config';

export const getPartnerTemplateName = (
  formatMessage: IntlShape['formatMessage'],
  partner: PartnerTemplatePartner,
): string =>
  formatMessage(
    partnerTemplateNameMessages[partner] ?? templatesMessages.unknownPartner,
  );
